import { IAutorizacoes } from './../../../interfaces/token/IAutorizacoes';
import { IPostInventarioBody } from './../../../interfaces/inventario/IPostInventarioBody';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IEstado } from 'src/app/interfaces';
import {
  IBGEService,
  InventarioService,
  AuthenticationService
} from 'src/app/services';
import { IInventario } from 'src/app/interfaces/inventario';
import { ModalGeneralComponent } from 'src/app/components/modal-general/modal-general.component';

@Component({
  selector: 'app-listagem-inventario-detalhes',
  templateUrl: './listagem-inventario-detalhes.component.html',
  styleUrls: ['./listagem-inventario-detalhes.component.scss']
})
// TODO: o por que do erro do formulário
// TODO: o formulário está dando erro pois o centro de custo está mockado, ele deve vir de um dropdown que ainda vai ser adicionado
// TODO: após adicionar esse dropdown (requisição) conferir os tipos, conferir se 'ultimaAlteracaoUsuarioID' corresponde ao id do usuario que esta enviando o formulario,
// TODO: ou seja, se é o usuario logado, e conferir por ultimo, de onde virá essa informação 'contratoAtual'
export class ListagemInventarioDetalhesComponent implements OnInit, OnDestroy {
  @ViewChild(ModalGeneralComponent) modalSucesso: ModalGeneralComponent;
  subscriptions$: Subscription = new Subscription();
  formGroup: FormGroup;
  states: IEstado[] = [];
  data: IInventario | any;
  token = this.authenticationService.obterToken();
  autorizacoes: IAutorizacoes;

  gerenciarPermissoesTela() {
    this.autorizacoes = this.authenticationService.obterToken()['autorizacoes'];
  }

  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private inventarioService: InventarioService,
    private authenticationService: AuthenticationService,
    private location: Location,
    private IBGEService: IBGEService
  ) {
    this.formGroup = this.formBuilder.group({
      // TODO manipular o drop down de centro de custo
      // centroCustoID: ['', [Validators.required]],
      centroCustoID: [''],
      siteDatabit: ['', [Validators.required]],
      nomeContatoPosse: ['', [Validators.required]],
      emailContatoPosse: ['', [Validators.required]],
      celularContatoPosse: [
        '',
        [Validators.required, Validators.minLength(15)]
      ],
      telefoneContatoPosse: [
        '',
        [Validators.required, Validators.minLength(15)]
      ]
    });
  }
  getStates() {
    this.subscriptions$.add(
      this.IBGEService.getEstados().subscribe({
        next: (response) => {
          this.states = response;
        }
      })
    );
  }
  getInventory(serialNumber: string) {
    this.subscriptions$.add(
      this.inventarioService
        .getInventario({
          idUsuario: this.token.id,
          numSerie: serialNumber,
          codGrupoEconomico: this.token.codGrupoEconomico,
          codContrato: this.token.codContrato
        })
        .subscribe({
          next: ({
            data: {
              registros: [inventario]
            }
          }) => {
            this.data = inventario;
          }
        })
    );
  }
  fecharModal() {
    this.modalSucesso.closeModal();
  }
  onFormSubmit() {
    const getNumSerie = this.activatedRoute.snapshot.params.Numserie;
    const formData = { ...this.formGroup.value };

    const body = {
      numeroSerieDatabit: getNumSerie,
      codigoContratoDatabit: this.data?.codigoContrato,
      // TODO isso será um DROPDOWN LIST quando mexermos na tabela de CENTRO DE CUSTO (valor mockado)
      centroCustoID: 0,
      ...formData,
      contratoAtual: true,
      ultimaAlteracaoUsuarioID: this.token.id
    } as IPostInventarioBody;
    this.subscriptions$.add(
      this.inventarioService.postInventario(body).subscribe({
        next: () => {},
        error: () => {}
      })
    );
    this.modalSucesso.openModal();
  }
  showAddActivityModal() {}
  ngOnInit() {
    this.getInventory(this.activatedRoute.snapshot.params.Numserie);
    this.getStates();
    this.gerenciarPermissoesTela();
  }
  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
